<template>
  <div :id="id" class="c-accordion-panel" v-if="isActive">
    <div class="c-accordion-panel__header" :class="{ 'c-accordion-panel__header-active': isExpanded }">
      <h3 class="c-accordion-panel__header-title" :id="titleId">{{ title }}</h3>
      <button v-if="showEditLink" class="c-accordion-panel__header-edit-selection" @click="setCurrentPanel(title)" tabindex="0">
        {{ isMobile && editLabelMobile ? editLabelMobile : editLabel }}
      </button>
    </div>
    <div v-if="isExpanded" class="c-accordion-panel__content" :class="{ 'c-accordion-panel__content--open js-active-accordion-panel': isExpanded }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    editLabel: {
      type: String,
      required: true
    },
    editLabelMobile: {
      type: String,
      required: false
    },
    isActive: {
      type: Boolean,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    titleId: {
      type: String,
      required: true,
    },
    showEditLink: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isMobile: window.innerWidth < 740,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 740;
    },
    setCurrentPanel(title) {
      this.$emit('setCurrentPanel', title);
    },
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/contact-us/_vue/AccordionPanel.vue